import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "SituacaoSinistro";
export const Listar = () =>
  RequestWebApi.get(`/${controller}/Listar`)
    .then(function (response) {
      const { resultData, success } = response.data;
      const situacoesSinistro = resultData;
      return { success, situacoesSinistro };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { situacoesSinistro: [] };
    });

export const Incluir = (situacaoSinistro) =>
  RequestWebApi.post(`/${controller}/Incluir`, situacaoSinistro)
    .then(function (response) {
      const { resultData, success } = response.data;
      const situacaoSinistro = resultData;
      return { success, situacaoSinistro };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Atualizar = (situacaoSinistro) =>
  RequestWebApi.put(`/${controller}/Atualizar`, situacaoSinistro)
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });

export const Remover = (situacaoSinistroId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { situacaoSinistroId: situacaoSinistroId },
  })
    .then(function (response) {
      const { success } = response.data;
      return { success };
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      const { success, message, errors } = error.response.data;
      return { success, message, errors };
    });
